// extracted by mini-css-extract-plugin
module.exports = {"text":"ContactDialog_text__1rOr9"};